<template>
    <div class="popup" v-show="show">
        <div class="create bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div class="title f18 bold500 txt_black87 tc">新建合伙人</div>
            <div class="content">
                <div class="item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        姓名：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入姓名"  v-model="data.name"/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        手机号（账号）：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入手机号"  v-model="data.phone"/>
                    </div>
                </div>
<!--                <div class="item txt_black54 f14 bold500 fl">-->
<!--                    <div class="title bold600 content-center">-->
<!--                        <Icon type="ios-star"/>-->
<!--                        请选择合伙人：-->
<!--                    </div>-->
<!--                    <div class="ipt">-->
<!--                        <input class="w100 h100 cursor_pointer" type="text" placeholder="请选择合伙人" v-model="data.user_name" @click="$refs.selectUser.init()"/>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        抽成比例：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" min="0" max="100" type="number"  v-model="data.commission"/>
                    </div>
                </div>
            </div>
            <div class="submit tc">
                <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="submitEvent">提交</button>
            </div>
        </div>

<!--        <select-user ref="selectUser" @confirmCallback="userCallback"></select-user>-->
    </div>
</template>

<script>
    // import SelectUser from '@/components/selectUser'
    export default {
        name: "create",
        components:{

        },
        data() {
            return {
                show: false,
                data: {
                    name: '',
                    phone: '',
                    // user_id: '',
                    // user_name: '',
                    commission: ''
                }
            }
        },
        methods: {
            init() {
                this.show = true;
                for(let v in this.data) {
                    this.data[v] = '';
                }
            },
            // userCallback(data) {
            //     this.data.user_id = data[0].id;
            //     this.data.user_name = data[0].name;
            // },
            submitEvent() {
                this.$api.post('/manage/partner',this.data).then((data) => {
                    this.$alert.success({content: '新建合伙人成功'});
                    this.show = false;
                    this.$emit('updateData');
                }).catch((error) => {
                    this.$alert.error({content: '新建合伙人失败'});
                });
            }
        }
    }
</script>

<style scoped>
    .create {
        width: 415px;
    }
    .content{
        padding: 0 30px;
    }
    .content > .item {
        margin-top: 30px;
        width: 355px;
    }

    .content > .item > div:nth-of-type(2) {
        height: 36px;
        line-height: 36px;
        margin-top: 8px;
    }

    .content > .item > .ipt > input {
        padding: 0 10px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
    }
     .submit {
        margin-top: 30px;
    }
</style>